const state = () => ({
  pinnedDepartments: [],
  returnMember: null,
})

const getters = {
  isPinned: (state) => (departmentId) => {
    return state.pinnedDepartments.includes(departmentId)
  }
}

const mutations = {
  setPinnedDepartments(state, pinnedDepartments) {
    state.pinnedDepartments = pinnedDepartments
  },
  setReturnMember(state, { memberId, departmentId }) {
    state.returnMember = { memberId, departmentId }
  },
  clearReturnMember(state) {
    state.returnMember = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}